import { skipToken, useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { Ansatt } from '../types/types'
import { throwOnError } from '../utils/throwOnError'

export const useGetAnsattByIdQuery = (id?: string) => {
  const { authFetch } = useAuth()
  return useQuery({
    staleTime: 1000 * 60 * 60 * 24, // 1 day
    queryKey: ['ansatte', id],
    queryFn:
      id != null && id.length > 0
        ? async () => {
            const { data, error } = await authFetch().GET(
              '/orgenhet-api/ansatte/{ansattid}',
              {
                params: {
                  path: {
                    ansattid: id
                  }
                }
              }
            )
            if (error) {
              throwOnError(error)
            }
            return data as Ansatt
          }
        : skipToken
  })
}
